export default __webpack_public_path__ + "cocoa_doorbell_v4w.0a6f478e.png";